import { render, staticRenderFns } from "./VaRatingItem.demo.vue?vue&type=template&id=db4f7524&"
import script from "./VaRatingItem.demo.vue?vue&type=script&lang=js&"
export * from "./VaRatingItem.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports